import { requiredString } from "common";
import { object, ref, string } from "yup";

export interface ChangePasswordPayload {
    password: string;
    confirmPassword: string;
}

export const PASSWORD_RULES_HINT = "At least twelve characters, including a letter and a number.";

/**
 * The same rules the API enforces. Checking them here keeps a password the API will refuse from
 * costing the seller an authentication code first. Rules the browser cannot know, such as whether the
 * password was used before, stay with the API.
 */
export const changePasswordValidationSchema = object().shape({
    password: requiredString()
        .min(12, "Should be at least twelve characters")
        .matches(/[a-zA-Z]/, "Should contain at least one letter")
        .matches(/\d/, "Should contain at least one number"),
    confirmPassword: string()
        .required()
        .oneOf([ref("password"), null], "must match"),
});

export const changePasswordInitialValues: ChangePasswordPayload = {
    password: "",
    confirmPassword: "",
};
